import {permissionObj} from "../../../../Helpers/permission";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import React from "react";
import {RESERVATIONS_SUB_VIEW_MODEL} from "../Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const BookingsMainHeader = ({
                                subView,
                                handleSubViewChange,
                                searchElement,
                                setSearchElement,
                                permission,
                                DEV,
                                option,
                                rowsPerPage,
                                setSearchResults,
                                searchResults,
                                setSearch,
                                simpleSearch,
                                setSimpleSearch,
                                viewType= null,
                                setBodyForExport
                            }) => {

    return (
        <div className='d-flex'>
            <div>
                <div className='d-flex'>
                    {(DEV || permission?.includes(permissionObj?.WEB_EVENT_READ)) &&
                    <ButtonAction
                        id='btn_bmh_requested'
                        name='requested'
                        className={RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            handleSubViewChange(RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST )
                        }}
                    />
                    }
                    {(DEV || permission?.includes(permissionObj?.WEB_EVENT_STATUS_READ)) &&
                    <ButtonAction
                        id='btn_bmh_status'
                        name='status'
                        className={RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.STATUS  === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            handleSubViewChange(RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.STATUS )
                        }}
                    />
                    }
                </div>

            </div>
            <div className='w-100'>
                <SearchSimple
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSearchResults={setSearchResults}
                    searchResults={searchResults}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={null}
                    supplierId={null}
                    viewType={viewType}
                    setBodyForExport={setBodyForExport}
                />
            </div>
        </div>)
}
export default BookingsMainHeader
